import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { EmbedSearchWidgetApiMetadata } from './types/EmbedSearchWidgetApiMetadata';

type ApiResponse = {
  embedSearchWidget: EmbedSearchWidgetApiMetadata;
};

function mapResponse(response: ApiResponse) {
  return response.embedSearchWidget;
}

const endpoint = new FetchEndpoint({
  urlFactory: (embedSearchWidgetId: ApiEmbedSearchWidgetId) =>
    `/data/website/embed-search-widgets/${embedSearchWidgetId}`,
  mapResponse,
});

// Exports

export const embedSearchWidgetIsomorphicApiFetchMetadata =
  endpoint.createIsomorphicFetchFn();
